/**
 * Generated by @openapi-codegen
 *
 * @version 1.0.0
 */
import * as reactQuery from 'app/src/shared/helpers/reactquery'
import { TutorialsContext, useTutorialsContext } from './tutorials-context'
import type * as Fetcher from './tutorials-fetcher'
import { tutorialsFetch } from './tutorials-fetcher'
import type * as Schemas from './tutorials-schemas'

export type TutorialRequestListQueryParams = {
  /**
   * Position of the first element to return
   *
   * @format int32
   * @default 0
   * @minimum 0
   */
  pagingOffset?: number
  /**
   * Maximum number of rows to return
   *
   * @format int32
   * @default 20
   * @minimum 1
   */
  pagingLimit?: number
}

export type TutorialRequestListHeaders = {
  ['X-Locale']?: string
}

export type TutorialRequestListError = Fetcher.ErrorWrapper<{
  status: 400
  payload: {
    /**
     * Error type
     */
    type: string
    /**
     * HTTP status
     */
    status: number
    /**
     * Error message
     */
    title: string
    /**
     * Unique return code
     *
     * @format int32
     */
    rc?: number
  }
}>

export type TutorialRequestListVariables = {
  headers?: TutorialRequestListHeaders
  queryParams?: TutorialRequestListQueryParams
} & TutorialsContext['fetcherOptions']

/**
 * Returns the list of the Tutorials
 */
export const fetchTutorialRequestList = (variables: TutorialRequestListVariables, signal?: AbortSignal) =>
  tutorialsFetch<
    Schemas.TutorialsPaginated,
    TutorialRequestListError,
    undefined,
    TutorialRequestListHeaders,
    TutorialRequestListQueryParams,
    {}
  >({ url: '/tutorials', method: 'get', ...variables, signal })

/**
 * Returns the list of the Tutorials
 */
export const useTutorialRequestList = <TData = Schemas.TutorialsPaginated>(
  variables: TutorialRequestListVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.TutorialsPaginated, TutorialRequestListError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useTutorialsContext(options)
  return reactQuery.useQuery<Schemas.TutorialsPaginated, TutorialRequestListError, TData>({
    queryKey: queryKeyFn({
      path: '/tutorials',
      operationId: 'tutorialRequestList',
      variables,
    }),
    queryFn: ({ signal }) => fetchTutorialRequestList({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type QueryOperation = {
  path: '/tutorials'
  operationId: 'tutorialRequestList'
  variables: TutorialRequestListVariables
}
